<template>
	<div class="color">
		<h2 class="unit_model-header">
			Unit Stomatologiczny <br />
			<small>{{ unit.fullName }}</small>
		</h2>
		<div class="color__carousel" v-if="colors.length > 0">
			<div class="color__description">
				<img :src="require(`@/assets/pictures/colors/${getColorFilename(selectedColorIndex)}`)" />
				<div class="color__description-text">
					<small>{{ selectedColorInfo.catalogNumber }}</small>
					<small>{{ selectedColorInfo.fullName }}</small>
				</div>
			</div>
			<a
				v-show="selectedColorIndex !== 0"
				class="color__carousel-nav-button color__carousel-nav-button--prev"
				@click.prevent="slidePrev"
			>
				<img :src="require('@/assets/arrow-left-black.svg')" />
			</a>
			<a
				v-show="selectedColorIndex !== colors.length - 1"
				class="color__carousel-nav-button color__carousel-nav-button--next"
				@click.prevent="slideNext"
			>
				<img :src="require('@/assets/arrow-right-black.svg')" />
			</a>
			<hooper
				ref="carousel"
				:centerMode="true"
				style="height: 500px"
				@slide="setColor"
				:wheelControl="false"
				:initialSlide="selectedColorIndex"
				:itemsToShow="1"
			>
				<slide
					v-for="(color, index) in colors"
					:key="`color__model-${index}`"
					class="color__carousel-item"
				>
					<img
						:src="require(`@/assets/pictures/model-colors/${getModelColorFilename(index)}`)"
						class="color__carousel-item-image"
					/>
				</slide>
			</hooper>
		</div>
		<h5 class="color__selection-heading">
			Wybierz kolor tapicerki
		</h5>
		<div class="color__selection-wrapper">
			<img
				v-for="(color, index) in colors"
				:key="`colors__${index}`"
				:class="[
					'color__selection',
					`color__selection--${color.name}`,
					{'color__selection--selected': selectedColor === color.name},
				]"
				:style="{borderColor: color.hexBorder}"
				@click="showModelInColor(index)"
				:src="require(`@/assets/pictures/colors/${getColorFilename(index)}`)"
			/>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import {Hooper, Slide} from 'hooper';
import 'hooper/dist/hooper.css';

import AppDataMixin from '@/mixins/app-data';

export default {
	name: 'Color',
	mixins: [AppDataMixin],
	components: {Hooper, Slide},
	data() {
		return {
			selectedColor: '',
			selectedColorIndex: 0,
			colors: [],
		};
	},
	computed: {
		modelNumber() {
			return this.unit.image.split('.')[0].split('-')[1];
		},
		selectedColorInfo() {
			return this.colors[this.selectedColorIndex];
		},
	},
	mounted() {
		this.colors = this.getAppData('colorsList');
		this.selectedColor = this.$store.state.unitConfiguration.color;
		this.selectedColorIndex = R.findIndex(R.propEq('name', this.selectedColor))(this.colors);
	},
	methods: {
		showModelInColor(index) {
			this.$refs.carousel.slideTo(index);
		},
		setColor({currentSlide: index}) {
			this.selectedColor = this.colors[index].name;
			this.selectedColorIndex = index;
			this.$store.commit('unitConfiguration/setColor', this.selectedColor);
		},
		slideNext() {
			this.$refs.carousel.slideNext();
		},
		slidePrev() {
			this.$refs.carousel.slidePrev();
		},
		getColorFilename(index) {
			const numberString = (index + 1).toString().padStart(2, '0');
			return `kolor-${numberString}.png`;
		},
		getModelColorFilename(index) {
			const numberString = (index + 1).toString().padStart(2, '0');
			return `kolor-${this.modelNumber}-${numberString}.jpg`;
		}
	},
};
</script>
